import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { tableStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListTable";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

tableStyles.dataTable = mergeToNew(tableStyles.dataTable, {
    css: css`
        th {
            background: ${getColor("secondary")};
        }
        tbody {
            tr {
                &:nth-child(even) {
                    background: ${getColor("secondary")};
                }
            }
        }
    `,
});
